import React from 'react';
import useTranslation from '~/app/hooks/useTranslation';

export interface CommentTextProps {
  value?: string | null;
}

export type CommentTextComponent = React.FC<CommentTextProps>;

const CommentText: CommentTextComponent = ({ value }) => {
  const { t } = useTranslation('training');
  const trimmed = value?.trim();
  return <>{trimmed ? value : t('noCommentAdded')}</>;
};

export default CommentText;
